(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/hooks/use-snake.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/hooks/use-snake.js');

'use strict';

const {
  useCallback,
  useState
} = React;
const {
  Snake
} = svs.components.marketplaceCompetition.overviewHero.common;
const useSnake = () => {
  const [visible, setVisible] = useState(false);
  const showGame = useCallback(() => {
    setVisible(true);
  }, []);
  return [showGame, visible ? Snake : undefined];
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.hooks.useSnake', useSnake);

 })(window);